// Self-contained type definitions - no dependency on GraphQL schema
// Copied from graph-api/src/generated/resolvers-types.ts
// These use optional + nullable pattern to match graph-api builder code

type Maybe<T> = T | null;

export enum CommissionType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

export enum CoverSheetIconType {
  dollar = 'dollar',
  percentage = 'percentage',
  autoAwesome = 'autoAwesome',
  uploadFile = 'uploadFile',
}

type ActionLabel = {
  primary?: Maybe<string>;
  secondary?: Maybe<string>;
};

type MapActionProp = {
  from: string;
  label?: Maybe<string>;
  to: string;
};

type DialogAction = {
  ariaLabel: string;
  label: string;
  type: string;
};

export type Dialog = {
  actions?: Maybe<DialogAction[]>;
  content: string;
  title: string;
  type: string;
};

type MlsAutofillFieldsAction = {
  number: string;
  vendorId: string;
};

export type Action = {
  constraints?: Maybe<string[]>;
  dialog?: Maybe<Dialog[]>;
  indices?: Maybe<number[]>;
  label?: Maybe<ActionLabel>;
  mlsAutofillFields?: Maybe<MlsAutofillFieldsAction>;
  name?: Maybe<string>;
  props?: Maybe<MapActionProp[]>;
  provider?: Maybe<string>;
};

type ShowWhen = {
  fieldName: string;
  hasValue: string;
};

type CardBanner = {
  index?: Maybe<number>;
  name: string;
};

export type CollapsibleDisplayField = {
  name: string;
  type?: Maybe<string>;
};

type CustomField = {
  label: string;
  name: string;
  placeholderText: string;
};

export type LabelWhen = {
  fieldName: string;
  hasValue: string;
  label: string;
};

export type Layout = {
  name: string;
  size: number;
  mobileSize?: Maybe<number>;
  tabletSize?: Maybe<number>;
  /**
   * Overrides `size`, which otherwise holds from `lg` up. Use it to keep a dense
   * row from packing in before there is room for it.
   */
  xl?: Maybe<number>;
};

export type Option = {
  disabled?: Maybe<boolean>;
  icon?: Maybe<string>;
  label: string;
  labelWhen?: Maybe<LabelWhen>;
  showWhen?: Maybe<ShowWhen>;
  value: string;
};

export type Validation = {
  appliesToIndex?: Maybe<number[]>;
  message?: Maybe<string>;
  type: string;
  value?: Maybe<string>;
};

export type Field = {
  name: string;
  entity?: Maybe<string>;
  entityType?: Maybe<string>;
  type: string;
  label: string;
  value?: Maybe<string>;
  placeholderText?: Maybe<string>;
  tooltip?: Maybe<string>;
  variant?: Maybe<string>;
  disabled?: Maybe<boolean>;
  disabledForIndex?: Maybe<number>;
  visibleForIndex?: Maybe<number>;
  maxLength?: Maybe<number>;
  labelWhen?: Maybe<LabelWhen>;
  validation?: Maybe<Validation[]>;
  options?: Maybe<Option[]>;
  customField?: Maybe<CustomField>;
  action?: Maybe<Action>;
  showWhen?: Maybe<ShowWhen>;
};

export type Card = {
  id: string;
  entity?: Maybe<string>;
  entityType?: Maybe<string>;
  innerTitle?: Maybe<string>;
  outerTitle?: Maybe<string>;
  maxAddable?: Maybe<number>;
  addableTitle?: Maybe<string>;
  isAddable?: Maybe<boolean>;
  addText?: Maybe<string>;
  addByDefault?: Maybe<boolean>;
  noEntryText?: Maybe<string>;
  hideByDefault?: Maybe<boolean>;
  syncsWithGoogleContacts?: Maybe<boolean>;
  width?: Maybe<string>;
  legend?: Maybe<string>;
  isCollapsible?: Maybe<boolean>;
  collapsedName?: Maybe<string[]>;
  disallowRemoveForIndex?: Maybe<number[]>;
  fields: Field[];
  layout?: Maybe<Maybe<Layout[]>[]>;
  banners?: Maybe<CardBanner[]>;
  displayFields?: Maybe<CollapsibleDisplayField[]>;
  action?: Maybe<Action>;
};

export type Section = {
  id: string;
  header: string;
  sidebarText: string;
  cards: Card[];
};

export type CoverSheetConfig = {
  locale: string;
  version?: Maybe<string>;
  sections: Section[];
};

// Builder helper types
export type CoverSheetConfigCard = Omit<Card, 'fields'> & {
  fields: Record<string, Field | null>;
  order?: number;
};

export type CoverSheetConfigSection = Omit<Section, 'cards'> & {
  cards: Record<string, CoverSheetConfigCard | null>;
};

type CoverSheetConfigObject = Omit<CoverSheetConfig, 'sections'> & {
  sections: Record<string, CoverSheetConfigSection>;
};

export type DefaultCoverSheetConfig = Omit<CoverSheetConfigObject, 'locale'>;

/**
 * Transforms a specific primitive value into its wider primitive type.
 * If the value is not a primitive the original type is returned.
 */
type ToPrimitive<T> = T extends string
  ? string
  : T extends number
    ? number
    : T extends boolean
      ? boolean
      : T;

/**
 * Broadens a specific type like { id: 'card', fields: {...} }
 * into a generic type like Card.
 */
type Broaden<T> = T extends Field
  ? Field
  : T extends Card | CoverSheetConfigCard
    ? CoverSheetConfigCard
    : T extends Section | CoverSheetConfigSection
      ? CoverSheetConfigSection
      : T extends DefaultCoverSheetConfig
        ? CoverSheetConfigObject
        : T extends Record<string, Field>
          ? Record<string, Field>
          : T extends Record<string, CoverSheetConfigCard>
            ? Record<string, CoverSheetConfigCard>
            : T extends Record<string, CoverSheetConfigSection>
              ? Record<string, CoverSheetConfigSection>
              : ToPrimitive<T>;

// Types that can be replaced with `null` to be removed
type NullableTypes = Field | CoverSheetConfigCard;

// Types that can be extended with new keys in the override object
type ExtendableTypes = Field | CoverSheetConfigCard | CoverSheetConfigSection;

/**
 * Describes a coversheet overrides object that can be processed by applyOverrides.
 *
 * Supports:
 * - Replacing already defined properties and subproperties of T with a value of the
 * same type. If the property has a type specified in `NullableTypes` it can also be
 * replaced with `null` to be removed.
 * - Specifying a mapper function to transform an existing defined property. Note that
 * nested mapper functions are not supported.
 * - Specifing new keys on extendable types, e.g. if a `Field` doesn't have `validation`
 * in the default config it can be added in the override.
 */
export type CoverSheetOverrides<T> =
  | Broaden<T>
  | (T extends (infer U)[]
      ? CoverSheetOverrides<U>[]
      : T extends object
        ? {
            [K in keyof T]?:
              | ((defaultValue: T[K]) => Broaden<T[K]>) // Allow mapping the existing property value
              // Allow defining new keys on extendable object types
              | (Broaden<T[K]> extends ExtendableTypes
                  ? Omit<Broaden<T[K]>, keyof T[K]>
                  : never)
              // Allow nulling nullable types
              | (Broaden<T[K]> extends NullableTypes ? null : never)
              // Allow replacing properties with any value that has same widened type
              | (K extends keyof Broaden<T> ? Broaden<T>[K] : never)
              // Recurse into subproperties
              | CoverSheetOverrides<T[K]>;
          }
        : T);

export type LocaleOverrides<T extends DefaultCoverSheetConfig> =
  CoverSheetOverrides<T> & { locale: string };
